import {Checkbox, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@mui/material";
import React, {useState} from "react";
import {makeStyles, withStyles} from "@mui/styles";
import CheckboxSubcomponent from "../exercisesubcomponents/CheckboxSubcomponent";
import CheckboxTableSubcomponent from "../exercisesubcomponents/CheckboxTableSubcomponent";
import ActionsComponent from "../components/ActionsComponent";
import globalVars from "../utils/globalVars";

const useStyles = makeStyles({
    tableCell: {
        // padding: '0.1em',
        // backgroundColor: "yellow"
    }
});
const StyledTableContainer = withStyles((theme) => ({
    root: {
        // width: "max-content"
    }
}))(TableContainer);

export default function MultipleChoiceComponent(props) {
    const [subtype, setSubtype] = useState(props.exercise?.subtype)
    const [columnLabelsWidth, setColumnLabelsWidth] = useState(
        props.exercise.subtype == 'table' ?
            Math.max(props.exercise.column_labels.true.length + props.exercise.column_labels.false.length + 0, 12)
            : 0
    )
    const [showSolution, setShowSolution] = useState(false);

    function handleShowSolution() {
        setShowSolution(!showSolution)
    }

    const [showFeedback, setShowFeedback] = useState(false);

    function handleShowFeedback() {
        setShowFeedback(!showFeedback)
    }

    // ### multiplechoice ###
    // OBLIGATORY_KEYS = ['id', 'meta', 'source', 'type']
    // STD_KEYS = ['hint', 'sentence', 'subtitle', 'title']
    //
    // answers.t
    // answers.v
    // column_labels.false
    // column_labels.true
    // header
    // numberanswers
    // sentencenr
    const classes = useStyles();
    return (
        <div key={props.index}>
            {/*<span style={{backgroundColor: 'yellow'}}>{subtype} {columnLabelsWidth.toString() + 'em'}</span>*/}
            {/*{<span style={{backgroundColor: 'yellow'}}>{props.exercise.answers}</span>}*/}
            {/*{*/}
            {/*    props.exercise.answers.map(*/}
            {/*        (r, ri) => {*/}
            {/*            return (<p>{r.t}</p>)*/}
            {/*        })*/}
            {/*}*/}
            <StyledTableContainer component="div">
                <Table style={{tableLayout: "auto"}} sx={{width: '70vw', border: '1px solid #ccc'}}
                       aria-label="simple table">
                    {props.exercise?.header &&
                    <TableHead>
                        <TableRow key={0}>
                            <TableCell key={0}>
                            </TableCell>
                            {
                                props.exercise.numberanswers &&
                                <TableCell key={1}>
                                </TableCell>
                            }
                            <TableCell key={2}
                                       align="left"
                                       sx={{
                                           fontWeight: 'bold',
                                           // backgroundColor: '#eee',
                                           padding: '0.5em',
                                           maxWidth: '100px'
                                       }}>
                                {props.exercise.header}
                            </TableCell>
                        </TableRow>

                    </TableHead>
                    }


                    <TableBody>
                        {
                            props.exercise.answers.map(
                                (r, ri) => {
                                    return (
                                        <TableRow key={ri} sx={{'&:last-child td, &:last-child th': {border: 0}}}>
                                            {
                                                props.exercise.numberanswers &&
                                                <TableCell className={classes.tableCell}
                                                           key={"tableCellBody_1_" + ri}
                                                           sx={{
                                                               paddingLeft: '0.8em',
                                                               paddingRight: '0em',
                                                               // minWidth: '1em',
                                                               // maxWidth: '1em',
                                                           }}
                                                >
                                                    <b>{ri + 1}.</b>
                                                </TableCell>
                                            }
                                            <TableCell key={"tableCellBody_2_" + ri} align="center"
                                                       sx={{
                                                           padding: '0.1em',
                                                           minWidth: subtype == 'table' ? columnLabelsWidth.toString() + 'em' : '3em',
                                                           maxWidth: subtype == 'table' ? columnLabelsWidth.toString() + 'em' : '3em',
                                                       }}
                                            >
                                                <>
                                                    {
                                                        subtype == 'table' ?
                                                            <CheckboxTableSubcomponent
                                                                key="1"
                                                                // feedbackMode={props.feedbackMode}
                                                                feedbackMode={showFeedback ? "mode_feedback" : "mode_normal"}
                                                                answers={props.exercise.column_labels}
                                                                expectedChecked={props.exercise.column_labels[r.v]}
                                                            />
                                                            : true
                                                    }
                                                    {
                                                        subtype == undefined ?
                                                            <CheckboxSubcomponent
                                                                key="2"
                                                                // feedbackMode={props.feedbackMode}
                                                                feedbackMode={showFeedback ? "mode_feedback" : "mode_normal"}
                                                                expectedChecked={r.v}
                                                            />
                                                            : true
                                                    }
                                                    {/*{*/}
                                                    {/*    subtype == 'onecheckbox' ?*/}
                                                    {/*        <CheckboxSubcomponent*/}
                                                    {/*            feedbackMode={props.feedbackMode}*/}
                                                    {/*            key="3"*/}
                                                    {/*            expectedChecked={r.v}*/}
                                                    {/*        />*/}
                                                    {/*        : true*/}
                                                    {/*}*/}
                                                </>
                                            </TableCell>
                                            <TableCell key={"tableCellBody_3_" + ri} align="left"
                                                       style={{
                                                           width: "100%",
                                                           backgroundColor: (r.v && showSolution)  ? globalVars.solutionMode.on : globalVars.solutionMode.off
                                                       }}
                                                       sx={{
                                                           padding: '0.5em',
                                                           // maxWidth: '100px'
                                                       }}
                                            >
                                                {r.t}
                                            </TableCell>
                                        </TableRow>
                                    )
                                }
                            )
                        }
                    </TableBody>
                </Table>
            </StyledTableContainer>
            {/*{props.exercise.sentence && <p>sentence = {props.exercise.sentence}</p>}*/}
            {/*{props.exercise.header && <p>header = {props.exercise.header}</p>}*/}
            {/*{props.exercise.numberanswers && <p>numberanswers = {props.exercise.numberanswers.toString()}</p>}*/}
            {/*{props.exercise.column_labels &&*/}
            {/*<p>column_labels = {JSON.stringify(props.exercise.column_labels, null, 2)}</p>}*/}
            <ActionsComponent
                onToggleShowSolution={handleShowSolution}
                onToggleShowFeedback={handleShowFeedback}
                {...props}
            />
        </div>
    );
}

/*
export function ExerciseMultipleChoiceOnecheckboxComponent(props) {
    return (
        <div key={props.index}>
            {/!*obligatory fields*!/}
            <p>answers = {JSON.stringify(props.exercise.answers, null, 2)}</p>
            {/!*optional fields*!/}
            {props.exercise.sentence && <p>sentence = {props.exercise.sentence}</p>}
            {props.exercise.title && <p>title = {props.exercise.title}</p>}
        </div>
    );
}

export function ExerciseMultipleChoiceTableComponent(props) {
    return (
        <div key={props.index}>
            {/!*obligatory fields*!/}
            <p>answers = {JSON.stringify(props.exercise.answers, null, 2)}</p>
            <p>column_labels = {JSON.stringify(props.exercise.column_labels, null, 2)}</p>
            <p>header = {props.exercise.header}</p>
            <p>title = {props.exercise.title}</p>
            {/!*optional fields*!/}
            {props.exercise.sentence && <p>sentence = {props.exercise.sentence}</p>}
            {props.exercise.numberanswers && <p>numberanswers = {props.exercise.numberanswers}</p>}
        </div>
    );
}

*/
